module.exports = __webpack_public_path__ + "static/media/file-audio.3d58b8cd.svg";